





































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class ManagementAttractiveness extends Vue {
  loading = false;

  menu = [
    {
      title: "Analisi",
      subtitle: "",
      children: [
        {
          title: "Analisi Attrattori",
          to: "/analysis-attractiveness",
        },
        {
          title: "Analisi Centri storici",
          to: "/analysis-historical-centres",
        },
      ],
    },
    {
      title: "Strategie",
      subtitle: "",
      to: "/attraction-strategies",
    },
    {
      title: "Iniziative",
      subtitle: "",
      to: "/attraction-initiative",
    },
  ];

  onSurveyTypeClick(to: string) {
    this.$router.push(to).catch(error => console.log(error));
  }
}
